import React from "react";
import styles from "./Library.module.css";
import { BiFile, BiDownload } from "react-icons/bi";
import documentFiles from "../../assets/documents";

const Library = () => {
  return (
    <section className={styles.librarySection}>
      <h2 className={styles.title}>Library</h2>
      <div className={styles.documentList}>
        {documentFiles.map((doc, index) => (
          <div key={index} className={styles.documentItem}>
            <BiFile className={styles.fileIcon} />
            <span className={styles.fileName}>{doc.name}</span>
            <a href={doc.link} download className={styles.downloadButton}>
              <BiDownload className={styles.downloadIcon} />
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Library;
